import { useEffect, useRef } from "react";

// Same effect as the original inline <script>'s scroll-reveal logic
// (elements with class="reveal" fade/slide in once, staggered, the first
// time they scroll into view) — just scoped per-section instead of one
// global querySelectorAll('.reveal') across the whole document.
//
// Usage in a section component:
//   const ref = useScrollReveal();
//   return <section ref={ref}>...<div className="reveal">...</div></section>
export default function useScrollReveal() {
  const containerRef = useRef(null);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return;

    const reveals = node.querySelectorAll(".reveal");
    if (reveals.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            setTimeout(() => entry.target.classList.add("visible"), i * 60);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );

    reveals.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return containerRef;
}
